import { ContentTag } from "scrivito"
import { PortalNewsPageObj } from "scrivito/Objs/PortalNewsPage/PortalNewsPageObjClass"
import { ScrivitoPageBreadcrumb } from "scrivito/scrivito-breadcrumb/ScrivitoPageBreadcrumb"

import { PortalNewsFilterFormData } from "entities/portal-news/types/PortalNewsFilter"
import { PortalNewsFilter } from "widgets/portal-news-list/PortalNewsFilter"
import {
  ScrivitoPortalNewsList,
  ScrivitoPortalNewsListModel
} from "widgets/portal-news-list/ScrivitoPortalNewsList"

export interface PortalNewsPageProps {
  filterState: PortalNewsFilterFormData
  setFilterState: ((filterState: PortalNewsFilterFormData) => void) | undefined
  page: PortalNewsPageObj | null | undefined
  portalNewsListModel: ScrivitoPortalNewsListModel
}

export function PortalNewsPage({
  page,
  filterState,
  portalNewsListModel,
  setFilterState
}: PortalNewsPageProps) {
  return page ? (
    <div className="page portal-news-page">
      <ScrivitoPageBreadcrumb page={page} />

      <div className="portal-news-page__header">
        <ContentTag
          tag="h1"
          content={page}
          attribute="title"
          className="portal-news-page__title"
        />
        <PortalNewsFilter.Root
          defaultValues={filterState}
          onChange={setFilterState}
        >
          <PortalNewsFilter.Search />
        </PortalNewsFilter.Root>
      </div>

      <div className="portal-news">
        <ScrivitoPortalNewsList {...portalNewsListModel} />
      </div>
    </div>
  ) : null
}
